export const titlelist = [
  { label: '联系人', value: 1 },
  { label: '共同贷款人', value: 2 },
  { label: '房产信息', value: 3 },
  { label: '车产信息', value: 4 },
  { label: '股东信息', value: 5 },
  { label: '产权所有人信息', value: 6 }
]

export const loanList = [
  {
    label: '个人汽车消费贷款',
    value: 1
  },
  {
    label: '个人经营性贷款',
    value: 2
  },
  {
    label: '经营性农户贷款',
    value: 3
  },
  {
    label: '消费性农户贷款',
    value: 4
  },
  {
    label: '其他个人消费贷款',
    value: 5
  },
  {
    label: '其他贷款',
    value: 6
  }
]

export const typeList = [
  { label: '等本等息', value: 6 },
  { label: '等额本息', value: 1 },
  { label: '等额本金', value: 2 },
  { label: '先息后本', value: 3 },
  { label: '一次性还本付息', value: 4 },
  { label: '其他约定还款', value: 5 }
]

export const applyList = [
  { label: '线上H5', value: 1 },
  { label: '分销商手动创建', value: 2 },
  { label: '小贷机构手动创建', value: 3 }
]

export const rateList = [
  { value: 1, label: '月' },
  { value: 2, label: '季度' },
  { value: 3, label: '年' }
]
export const dateList = [
  { value: 1, label: '顺延' },
  { value: 0, label: '不顺延' }
]

// 只上传一张的field
export const pictureArr = [
  'idCardFront',
  'idCardBack',
  'subLoanIdCardFront',
  'subLoanIdCardBack',
  'legalEntityIdCardFront',
  'legalEntityIdCardBack',
  'actualEntityIdCardFront',
  'actualEntityIdCardBack'
]

// 字段 确定精度
export const precisionsObj: { [x: string]: number } = {
  expectLoanMoney: 4, // 期望贷款金额
  currentCity: 3, // 当前所在城市
  currentAddress: 1, // 现住地址
  permanentResidenceAddress: 1, // 详细地址
  annualIncome: 6, // 综合年收入
  monthlyIncomeAfterTax: 6, // 税后月收

  contributionBase: 4, // 公积金缴存基数
  gjjBalance: 4, // "公积金余额"

  personTaxBase: 4, // 个人税缴纳基数
  payingCity: 3, // 缴纳城市

  enterpriseAddress: 1, // "企业联系地址"
  enterpriseRegisterAddress: 1, // "企业注册地址"
  enterpriseRegisterMoney: 6, // 企业注册金额
  enterpriseIncomeSum: 6, // 企业本年收入总计
  enterpriseLastYearIncomeSum: 6, // 企业去年年收入
  enterpriseDbSum: 6, // 企业对外担保总额
  // 发票信息
  enterpriseFromMoney: 6, // 订单金额
  invoiceMoney: 6, // 发票金额

  totalCurrentLiabilities: 6, // 当前负债总额
  totalAmountUsedCreditCard: 6, // 信用卡已用总额
  totalCreditCardBalance: 6, // 信用卡欠款总额
  totalGuaranteeCount: 6, // 担保总额

  subLoanAddress: 1, // 现住地址
  subHouseAddress: 1, // 地址
  subHouseEstimatedValue: 4, // 评估价值(万)
  subCarRegistrationArea: 3, // 上牌区域
  subCarKmSum: 2, // 车辆公里数
  subCarYearTime: 2, // 持有时长（年）
  subCarAssessMoney: 4, // 评估价值（万）
  subShareholderLinkAddress: 1, // "联系地址"
  subHouseEndTime: 2, // 产权截至日期
  idcardStartExpired: 2, // 身份证日期
  legalIdcardExpired: 2, // 身份证日期
  birthday: 2,
  subHouseBuildingM: 2, // 房屋建筑面积（㎡）
  subHouseLandUseArea: 2 // 土地使用权面积（㎡）
}

// 字段 确定单位
export const unitObj: { [x: string]: string } = {
  expectLoanMoney: '万',
  annualIncome: '万',
  monthlyIncomeAfterTax: '万',

  contributionBase: '元',
  gjjBalance: '元',

  enterpriseRegisterMoney: '万',
  enterpriseIncomeSum: '万',
  enterpriseLastYearIncomeSum: '万',
  enterpriseDbSum: '万',

  enterpriseFromMoney: '万',
  invoiceMoney: '万',

  totalCurrentLiabilities: '万',
  totalAmountUsedCreditCard: '万',
  totalCreditCardBalance: '万',
  totalGuaranteeCount: '万',
  subHouseEstimatedValue: ' ',
  subCarAssessMoney: ' ',
  subHouseBuildingM: ' ',
  subHouseLandUseArea: ' '
}
// 去除空格字段
export const trimKeys: string[] = [
  'name',
  'phone',
  'idCard',
  'enterpriseName',
  'actualControlPersonType',
  'actualControlPersonIdCard',
  'actualControlPersonCode',
  'actualControlPersonPhone',
  'legalEntityIdCard',
  'legalEntityPhone',
  'legalEntityName',
  'subEnterpriseName',
  'subCreditCode',
  'subPropertyOwnerInfoName',
  'subPropertyOwnerInfoIdCard',
  'subPropertyOwnerInfoPhone',
  'subCarAllPerson',
  'subCarAllPersonIdCard',
  'subCarAllPersonPhone',
  'subHouseOwner',
  'subHouseAllPersonIdCard',
  'subHouseAllPersonPhone',
  'subLoanName',
  'subLoanPhone',
  'subLoanIdCard'
]
export const maxAomuntKeys: string[] = ['expectLoanMoney']

export const maxAmountUnitYuanKyes: string[] = []

// 办理状态
export enum HandleStatusEnum {
  waitHandle = 0, // 待办理
  handleing, // 办理中
  hasHandle // 已办理
}

// 抵押类型
export enum MortgageType {
  houseLoan = 0, // 房抵贷
  carLoan // 车抵贷
}

// 还款状态名称
export const repaymentStatusList = [
  { label: '待结清', value: 0 },
  { label: '正常结清', value: 1 },
  { label: '已逾期', value: 2 },
  { label: '逾期结清', value: 3 }
]

// 还款状态枚举值
export enum RePayStatusValue {
  waiting = 0,
  repaid = 1,
  overdue = 2,
  overdueRepaid = 3,
  GUARANTY_WAIT_PROCESS = 4,
  OUTSTANDING_LOAN = 5
}

// 金额正则
export const moneyExp = /^(?:\d{1}\.\d{1,2}|\d+\.\d{1,2}|\d+)$/

// 合同状态
export const contactList = [
  { value: 10, label: '签署中' },
  { value: 20, label: '已完成' },
  { value: 30, label: '已撤回' },
  { value: 40, label: '已拒绝' },
  { value: 50, label: '已过期' },
  { value: 60, label: '已失败' },
  { value: 70, label: '未发送' },
  { value: 80, label: '已作废' }
]
export const loanTypeList = [
  { label: '个人贷', value: 1 },
  { label: '企业贷', value: 2 }
]

export const jointLoanFlagList = [
  { label: '是', value: 1 },
  { label: '否', value: 0 }
]
export const productStatus = [
  { label: '启用', value: 1 },
  { label: '禁用', value: 0 }
]
export const loanBtn = [RePayStatusValue.GUARANTY_WAIT_PROCESS, RePayStatusValue.OUTSTANDING_LOAN]

export const loanType = [
  { label: '线上放款', value: 1 },
  { label: '线下放款', value: 2 }
]

export const billStatus = [
  { label: '待结清', value: 0 },
  { label: '待生效', value: 3 },
  { label: '已结清', value: 2 },
  { label: '已逾期', value: 1 }
]

export const repaymentTypes = [
  { label: '等本等息', value: 6 },
  { label: '等额本息', value: 1 },
  { label: '等额本金', value: 2 },
  { label: '先息后本', value: 3 },
  { label: '到期还本付息', value: 4 },
  { label: '其他约定还款', value: 5 }
]

export const levelTypes = [
  { label: '正常', value: 1 },
  { label: '关注', value: 2 },
  { label: '次级', value: 3 },
  { label: '可疑', value: 4 },
  { label: '损失', value: 5 }
]
